import { Button, Flex, Text, Icon, HStack, Circle } from '@chakra-ui/react';

import { MdChevronLeft, MdChevronRight } from 'react-icons/md';
import { BiDotsHorizontalRounded } from 'react-icons/bi';

function Pagination({
  totalItems,
  itemCount,
  currentPage,
  perPage,
  pageCount,
  totalPages, // Alternative API prop
  gotoPage,
  onPageChange, // Alternative API prop
  previousPage,
  nextPage,
  maxVisible = 5,
  limit,
  showItemsInfo = true, // New prop to control showing items info
}) {
  // Handle alternative API
  const actualPageCount = pageCount || totalPages;
  const actualGotoPage = gotoPage || onPageChange;
  const actualPreviousPage =
    previousPage || (() => actualGotoPage && actualGotoPage(currentPage - 1));
  const actualNextPage =
    nextPage || (() => actualGotoPage && actualGotoPage(currentPage + 1));
  const canPreviousPage = currentPage > 1;
  const canNextPage = currentPage < actualPageCount;
  const totalItemsCount = totalItems || itemCount || 0;
  const visiblePages = Math.min(maxVisible, actualPageCount);
  const visiblePagesStart = Math.max(
    1,
    currentPage - Math.floor(visiblePages / 2),
  );
  const visiblePagesEnd = Math.min(
    actualPageCount,
    visiblePagesStart + visiblePages - 1,
  );
  const visiblePagesArray = Array.from(
    { length: visiblePagesEnd - visiblePagesStart + 1 },
    (v, k) => k + visiblePagesStart,
  );
  const showing = `Menampilan ${
    limit
      ? totalItemsCount < limit
        ? totalItemsCount
        : limit
      : totalItemsCount < 10
      ? totalItemsCount
      : 10
  } dari ${totalItemsCount} hasil`;

  return (
    <Flex
      direction={{ base: 'column', md: 'row' }}
      gap={2}
      justify="space-between"
      align="center"
      my={5}
    >
      {showItemsInfo && (
        <Text fontSize="sm" lineHeight={5}>
          {showing}
        </Text>
      )}
      <HStack gap="1px">
        <Button
          size="xs"
          onClick={() => actualPreviousPage()}
          disabled={!canPreviousPage}
        >
          <Icon as={MdChevronLeft} />
        </Button>
        {currentPage >= maxVisible && actualPageCount > maxVisible && (
          <Circle>
            <BiDotsHorizontalRounded />
          </Circle>
        )}
        {visiblePagesArray.map((num) => (
          <Button
            key={num}
            size="xs"
            onClick={() => actualGotoPage(num)}
            _active={{ bg: 'cyan.700', color: 'white', border: 'none' }}
            backgroundColor="white"
            isActive={num === currentPage}
            borderColor="gray.200"
            borderWidth="1px"
          >
            {num}
          </Button>
        ))}
        {currentPage < maxVisible && actualPageCount > maxVisible && (
          <Circle>
            <BiDotsHorizontalRounded />
          </Circle>
        )}
        <Button
          size="xs"
          onClick={() => actualNextPage()}
          disabled={!canNextPage}
        >
          <Icon as={MdChevronRight} />
        </Button>
      </HStack>
    </Flex>
  );
}

export default Pagination;
